import { Span } from '@pcln/horizon'
import { Box, Button, Flex, Text } from 'pcln-design-system'
import { Discount } from 'pcln-icons'

export default function MemberCapture({ onButtonClick }: { onButtonClick: () => void }) {
  return (
    <div className='m-auto max-w-7xl px-0 pt-16 pb-8 md:px-8 lg:px-16 xl:px-8'>
      <Flex flexDirection={['column', null, null, null, 'row']}>
        <Box
          m={['auto', null, null, null, 0]}
          color='primary'
          style={{ borderRadius: '100%' }}
          width={['48px', null, null, null, '72px']}
          height={['48px', null, null, null, '72px']}
        >
          <Discount color='#FFF100' p={[2, null, null, null, 3]} size='100%' />
        </Box>
        <Box px={4} py={[3, null, null, null, 0]}>
          <Text
            color='primary'
            fontSize={[3, null, 4, null, null, 5]}
            textAlign={['center', null, null, null, 'left']}
          >
            Have you booked with Priceline in the past?
          </Text>
          <Text
            color='text.light'
            fontSize={[0, null, 1, null, null, 2]}
            mt={[2, null, null, 1]}
            textAlign={['center', null, null, null, 'left']}
          >
            You may instantly qualify for a higher VIP level!
          </Text>
        </Box>
        <Box borderRadius='2px' mr={['auto', null, null, null, 0]} ml='auto'>
          <Button
            onClick={() => {
              onButtonClick()
            }}
          >
            <Text fontSize={[0, null, 1, null, 2]} fontWeight='bold'>
              Sign up and find out
            </Text>
            <Span className='sr-only'>if you&apos;ve booked with Priceline in the past</Span>
          </Button>
        </Box>
      </Flex>
    </div>
  )
}
